module.exports = __webpack_public_path__ + "img/a6df5ed8644a90103f5738cc3c7cff51.png";